import dashboardModule from './role_permissions/dashboard';
import clientOrderManagementModule from './role_permissions/client_order_management';
import serviceManagementModule from './role_permissions/service_management';
import billingModule from './role_permissions/billing';
import hrManagementModule from './role_permissions/hr_management';
import complianceCalendarModule from './role_permissions/compliance_calendar';
import documentManagementModule from './role_permissions/document_management';
import passwordVaultModule from './role_permissions/password_vault';
import referralManagementModule from './role_permissions/referral_management';
import settingsModule from './role_permissions/settings';

const rolePermissionsData = [
  dashboardModule,
  clientOrderManagementModule,
  serviceManagementModule,
  billingModule,
  hrManagementModule,
  complianceCalendarModule,
  documentManagementModule,
  passwordVaultModule,
  referralManagementModule,
  settingsModule,
];

export default rolePermissionsData;
